import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Resources from "./pages/Resources";
import Intake from "./pages/Intake";
import Admin from "./pages/Admin";
import Anxiety from "./pages/Anxiety";
import Ocd from "./pages/Ocd";
import Stress from "./pages/Stress";
import WhatsAppFloater from "./components/WhatsAppFloater";

function GlobalFloater() {
  const location = useLocation();
  // Hide WhatsApp floater on admin pages (practitioner-facing, not client-facing)
  if (location.pathname.startsWith("/admin")) return null;
  return <WhatsAppFloater />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/intake" element={<Intake />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/anxiety" element={<Anxiety />} />
          <Route path="/ocd" element={<Ocd />} />
          <Route path="/stress" element={<Stress />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <GlobalFloater />
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
